function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import OptionCard from '../option-card';
import SuggestionHeading from '../suggestion-heading';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Suggestions = _ref => {
  var suggestions = _ref.suggestions,
    queryText = _ref.queryText,
    immediateTypes = _ref.immediateTypes,
    singleSelect = _ref.singleSelect,
    highlightedIndex = _ref.highlightedIndex,
    indexOffset = _ref.indexOffset,
    getItemProps = _ref.getItemProps,
    onItemClick = _ref.onItemClick,
    buildGroupName = _ref.buildGroupName;
  var appearance = item => {
    if (immediateTypes.includes(item.type)) {
      return 'immediate';
    }
    return singleSelect ? 'single' : 'multi';
  };
  var lastGroup;
  return ___EmotionJSX("div", null, ___EmotionJSX("ul", null, suggestions.map((item, index) => {
    var groupName = buildGroupName === null || buildGroupName === void 0 ? void 0 : buildGroupName(item);
    var showGroupName = groupName && groupName !== lastGroup;
    lastGroup = groupName;
    return ___EmotionJSX("li", _extends({
      key: "".concat(item.type).concat(item.id).concat(item.name),
      "data-testid": item.name
    }, getItemProps({
      item,
      index: index + indexOffset
    })), showGroupName && ___EmotionJSX(SuggestionHeading, null, groupName), ___EmotionJSX(OptionCard, {
      selected: index + indexOffset === highlightedIndex,
      item: item,
      searchText: queryText,
      appearance: appearance(item),
      onClick: onItemClick
    }));
  })));
};
Suggestions.propTypes = {
  queryText: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.shape),
  buildGroupName: PropTypes.func,
  immediateTypes: PropTypes.arrayOf(PropTypes.string),
  singleSelect: PropTypes.bool,
  highlightedIndex: PropTypes.number,
  indexOffset: PropTypes.number,
  getItemProps: PropTypes.func,
  onItemClick: PropTypes.func
};
Suggestions.defaultProps = {
  queryText: '',
  suggestions: [],
  buildGroupName: () => undefined,
  immediateTypes: [],
  singleSelect: false,
  highlightedIndex: -1,
  indexOffset: 0,
  getItemProps: () => {},
  onItemClick: () => {}
};
export default Suggestions;